import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "@/components/pages/Login";
import Dashboard from "@/components/pages/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import DashboardLayout from "@/components/templates/DashboardLayout";
import GroupManagement from "@/components/pages/GroupManagement";
import UserManagement from "@/components/pages/UserManagement";
import Moderation from "@/components/pages/Moderation";
import Finance from "@/components/pages/Finance";
import Messages from "@/components/pages/Messages";
import Events from "@/components/pages/Events";
import Support from "@/components/pages/Support";
import Settings from "@/components/templates/Settings";
import Roles from "@/components/pages/settingspages/Roles";
import Integrations from "@/components/pages/settingspages/Integrations";
import System from "@/components/pages/settingspages/System";
import Audit from "@/components/pages/settingspages/Audit";
import Policies from "@/components/pages/settingspages/Policies";
// import IntegrationsContent from "@/components/pages/settingspages/IntegrationsContent";
// import Users from "@/components/pages/Users";
// import UserDetail from "@/components/pages/UserDetail";
// import Analytics from "@/components/pages/Analytics";
// import Settings from "@/components/pages/Settings";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public login route */}
        <Route path="/login" element={<Login />} />

        {/* Protected admin routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Routes>
                  <Route
                    path="/"
                    element={<Navigate to="/dashboard" replace />}
                  />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/user" element={<UserManagement />} />
                  <Route path="/groups" element={<GroupManagement />} />
                  <Route path="/moderation" element={<Moderation />} />
                  <Route path="/finance" element={<Finance />} />
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/support" element={<Support />} />
                  {/* Settings routes */}
                  <Route path="/settings" element={<Settings />}>
                    <Route
                      path="/settings/"
                      element={<Navigate to="roles" replace />}
                    />
                    <Route path="roles" element={<Roles />} />
                    <Route path="integrations" element={<Integrations />} />
                    <Route path="system" element={<System />} />
                    <Route path="audit" element={<Audit />} />
                    <Route path="policies" element={<Policies />} />
                  </Route>
                  {/* <Route path="/users" element={<Users />} />
                  <Route path="/users/:id" element={<UserDetail />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/settings" element={<Settings />} /> */}

                  {/* Catch all - redirect to dashboard  */}
                  <Route
                    path="*"
                    element={<Navigate to="/dashboard" replace />}
                  />
                </Routes>
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
